import React, { useEffect } from "react";
import { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import Logo from '../../../../public/images/logo-new.svg';
import { ImageContainer, Subtitle, Title, TitleContainer } from "../BasicInfo/BasicInfo.styles";
import { CursorLoadingContainer } from "./Success.styles";

interface SuccessProps extends WithRouterProps {
}

const Success: React.FC<SuccessProps> = ({
    router
}) => {
    useEffect(() => {
      const delayInMilliseconds = 3000;

      const timeoutId = setTimeout(() => {
          router.push('/login');
      }, delayInMilliseconds);

      return () => clearTimeout(timeoutId);
    }, []); 

    return (
        <CursorLoadingContainer>
          <ImageContainer>
            <Logo />
          </ImageContainer>
          <TitleContainer>
            <Title>Your Password has Been Reset</Title>
            <Subtitle>
              Buckle up! We're guiding you to the login page...
            </Subtitle>
          </TitleContainer>
        </CursorLoadingContainer>
    );
};

Success.displayName = "Success";

const ComponentWithRouter = withRouter(Success)

export { ComponentWithRouter as Success };